<template>
  <div>
    <YsDataTable
      ref="refuseTable"
      v-model="refresh"
      :list="searchList"
      :button-list="buttonList"
      :fetch-method="fetchMethod"
      :columns="columns"
      use-data-field
      page-size-alias="pagesize"
      max-height="600"
    >
      <template #goods_img="{ row }">
        <img v-viewer :src="row.goods_img" class="goods_img" alt="" />
      </template>
      <template #table-title>
        <div style="text-align: right">
          <el-button type="danger" size="mini" @click="openRejectionTimeModal">
            设置驳回时间</el-button
          >
        </div>
      </template>
      <template #evidence_img="{ row }">
        <img
          v-for="(src, i) in row.evidence_img.slice(0, 3)"
          :key="src"
          :src="src"
          class="goods_img"
          alt=""
          @click="handleViewImage(row.evidence_img, i)"
        />
      </template>
      <template #actions="{ row, index }">
        <template v-if="row.status === constantMap.waitCheck">
          <el-button
            size="small"
            type="primary"
            style="margin: 4px"
            @click="handlePass(row, index)"
          >
            通过
          </el-button>
          <el-button
            size="small"
            type="danger"
            style="margin: 4px"
            @click="handleReject(row, index)"
          >
            驳回
          </el-button>
        </template>
        <template
          v-if="
            row.status === constantMap.passed &&
            row.custom_result === constantMap.waitDeal
          "
        >
          <el-button
            size="small"
            type="danger"
            style="margin: 4px"
            @click="handleAbandon(row, index)"
          >
            弃件
          </el-button>
          <el-button
            size="small"
            type="primary"
            style="margin: 4px"
            @click="handleSendBack(row, index)"
          >
            寄出
          </el-button>
          <el-button
            size="small"
            type="warning"
            style="margin: 4px"
            @click="handleRestock(row, index)"
          >
            重新入库
          </el-button>
        </template>
        <template v-if="row.status !== constantMap.waitCheck">
          <el-button
            size="small"
            style="margin: 4px"
            @click="handleViewLog(row, index)"
          >
            查看日志
          </el-button>
        </template>
      </template>
    </YsDataTable>
    <!-- 通过弹窗 -->
    <el-dialog
      :visible.sync="isVisiblePass"
      :close-on-click-modal="false"
      title="仓储备注"
      @close="handlePassDialogClose"
    >
      <YsInput
        v-model="storehouse_remark"
        type="textarea"
        placeholder="请填写仓储备注"
      />
      <template #footer>
        <el-button @click="isVisiblePass = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmPass">确定</el-button>
      </template>
    </el-dialog>
    <!-- 寄出弹窗 -->
    <el-dialog
      :visible.sync="isVisibleSendBack"
      :close-on-click-modal="false"
      width="520px"
      title="确认寄出"
      @close="handleSendBackDialogClose"
    >
      <el-form
        ref="formSend"
        :model="formSend"
        :rules="formSendRules"
        label-width="100"
      >
        <el-form-item label="寄出单号" prop="mailExpressNo">
          <YsInput
            v-model="formSend.mailExpressNo"
            placeholder="请填写寄出单号"
          ></YsInput>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="isVisibleSendBack = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmSendBack">
          确定
        </el-button>
      </template>
    </el-dialog>
    <!-- 日志弹窗 -->
    <el-dialog :visible.sync="isVisibleLog" title="日志列表">
      <YsDataTable
        v-model="refreshLog"
        :init-params="{ id: currentRow.id }"
        :fetch-method="fetchMethodLog"
        :use-pagination="false"
        :columns="columnsLog"
        use-data-field
      ></YsDataTable>
    </el-dialog>
    <!-- 驳回时间弹窗 -->
    <el-dialog
      :visible.sync="rejectionTimeModalVisible"
      title="请设置驳回时间"
      width="280px"
      @close="handleRejectionTimeModalClose"
    >
      <el-form
        ref="refRejectionTime"
        :model="formRejectionTime"
        :rules="rulesRejectionTime"
        :inline="false"
        size="normal"
      >
        <el-form-item prop="dayNum">
          <el-input v-model="formRejectionTime.dayNum"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="confirmRejectionTime">
          确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 确认重新入库弹窗 -->
    <el-dialog
      :visible.sync="warehousingConfirmModalVisible"
      title="确认重新入库？"
      width="280px"
      @close="handleWarehousingConfirmModalClose"
    >
      <el-form
        ref="refWarehousing"
        :model="formWarehousing"
        :rules="rulesRejectionTime"
        :inline="false"
        size="normal"
      >
        <el-form-item prop="reason_type" label="重新入库原因：">
          <el-radio-group v-model="formWarehousing.reason_type">
            <el-radio label="1">首次豁免</el-radio>
            <el-radio label="2">误判</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
          type="default"
          @click="warehousingConfirmModalVisible = false"
        >
          取 消</el-button
        >
        <el-button type="primary" @click="confirmWarehousing"> 确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as dayjs from "dayjs";
import * as unReasonableRefundApi from "@/controller/unReasonableRefund3386.js";
import rules from "@/const/rules.js";
import apiBaseURL from "@/utils/baseUrl.js";

const constantMap = {
  statusOptions: [
    { label: "待审核", value: "1" },
    { label: "通过", value: "2" },
    { label: "驳回", value: "3" },
  ],
  waitCheck: "1",
  passed: "2",
  rejected: "3",
  waitDeal: "0", // 待处理
};

export default {
  name: "RefuseWorkList",
  data() {
    return {
      constantMap,
      refresh: false,
      searchList: [
        {
          tag: "input",
          label: "拒收工单ID",
          field: "id",
        },
        {
          tag: "input",
          label: "售后工单ID",
          field: "work_id",
          props: {
            pattern: "positiveInt",
          },
        },
        {
          tag: "input",
          label: "客服工单ID",
          field: "customer_work_id",
          props: {
            pattern: "positiveInt",
          },
        },
        {
          tag: "input",
          label: "拆包运单号",
          field: "unpacking_express_no",
        },
        {
          tag: "input",
          label: "用户寄回运单号",
          field: "back_shipping_no",
        },
        {
          tag: "input",
          label: "商品货号",
          field: "goods_no",
          props: {
            pattern: "positiveInt",
          },
        },
        {
          tag: "input",
          label: "用户ID",
          field: "user_id",
          props: {
            pattern: "positiveInt",
          },
        },
        {
          tag: "input",
          label: "寄出快递单号",
          field: "mail_express_no",
        },
        {
          tag: "select",
          label: "选择状态",
          field: "status",
          options: constantMap.statusOptions,
        },
        {
          tag: "date",
          label: "拆包时间",
          field: "submit_time",
          props: {
            type: "daterange",
            defaultTime: ["00:00:00", "23:59:59"],
          },
          defaultValue: [
            dayjs().subtract(6, "day").format("YYYY-MM-DD 00:00:00"),
            dayjs().format("YYYY-MM-DD 23:59:59"),
          ],
          transform: (list) => {
            return {
              submit_time: list
                ? list.map((date) => dayjs(date).format("YYYY-MM-DD HH:mm:ss"))
                : "",
            };
          },
        },
        {
          tag: "date",
          label: "处理时间",
          field: "handle_time",
          props: {
            type: "daterange",
            defaultTime: ["00:00:00", "23:59:59"],
          },
          transform: (list) => {
            return {
              handle_time: list
                ? list.map((date) => dayjs(date).format("YYYY-MM-DD HH:mm:ss"))
                : "",
            };
          },
        },
      ],
      buttonList: [
        {
          tag: "button",
          text: "导出",
          props: {
            type: "success",
          },
          event: {
            handler: (params) =>
              unReasonableRefundApi.getList({ ...params, is_excel: "1" }),
            success: (res) => window.open(apiBaseURL + res.file),
          },
        },
      ],
      fetchMethod: unReasonableRefundApi.getList,
      columns: [
        {
          label: "拒收工单ID",
          prop: "no",
        },
        {
          label: "拆包时间",
          prop: "submit_time",
        },
        {
          label: "售后工单",
          prop: "work_id",
        },
        {
          label: "客服工单",
          prop: "customer_work_id",
        },
        {
          label: "拆包人",
          prop: "submit_admin",
        },
        {
          label: "拆包运单号",
          prop: "unpacking_express_no",
        },
        {
          label: "用户寄回运单号",
          prop: "back_shipping_no",
        },
        {
          label: "商品图片",
          slot: "goods_img",
        },
        {
          label: "商品货号",
          prop: "goods_no",
        },
        {
          label: "用户ID",
          prop: "user_id",
        },
        {
          label: "件数",
          prop: "goods_num",
        },
        {
          label: "仓位",
          prop: "as_refund_position",
        },
        {
          label: "存证图片",
          slot: "evidence_img",
          width: "230",
        },
        {
          label: "备注",
          prop: "remark",
        },
        {
          label: "审核状态",
          prop: "status_msg",
        },
        {
          label: "寄出快递单号",
          prop: "mail_express_no",
        },
        {
          label: "处理时间",
          prop: "handle_time",
        },
        {
          label: "处理结果",
          prop: "custom_result_msg",
        },
        {
          label: "操作",
          slot: "actions",
          fixed: "right",
        },
      ],
      currentRow: {}, // 当前操作项数据
      currentIndex: null, // 当前操作项
      isVisiblePass: false,
      storehouse_remark: "",
      isVisibleLog: false,
      refreshLog: false,
      fetchMethodLog: unReasonableRefundApi.getLog,
      columnsLog: [
        {
          label: "操作事件",
          prop: "event",
        },
        {
          label: "操作内容",
          prop: "content",
        },
        {
          label: "操作人",
          prop: "admin_name",
        },
        {
          label: "操作时间",
          prop: "created_at",
        },
      ],
      isVisibleSendBack: false,
      formSend: {
        mailExpressNo: "", // 寄出快递单号
      },
      formSendRules: {
        mailExpressNo: rules.ruleBlur,
      },
      rejectionTimeModalVisible: false,
      formRejectionTime: {
        dayNum: "",
      },
      rulesRejectionTime: {
        dayNum: [
          {
            required: true,
            message: "请输入正确的时间",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (!Number.isInteger(Number(value))) {
                  callback(new Error("请填写正整数！"));
                  if (Number(value) > 365) {
                    callback(new Error("请勿设置超过365天！"));
                  } else if (Number(value) < 1) {
                    callback(new Error("请填写正整数！"));
                  } else {
                    callback();
                  }
                } else {
                  callback();
                }
              }
            },
          },
        ],
      },
      rulesWarehousing: {
        reason_type: [
          {
            required: true,
            message: "请选择重新入库原因",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (!Number.isInteger(Number(value))) {
                  callback(new Error("请填写正整数！"));
                  if (Number(value) > 365) {
                    callback(new Error("请勿设置超过365天！"));
                  } else if (Number(value) < 1) {
                    callback(new Error("请填写正整数！"));
                  } else {
                    callback();
                  }
                } else {
                  callback();
                }
              }
            },
          },
        ],
      },
      warehousingConfirmModalVisible: false,
      formWarehousing: {
        reason_type: "1",
      },
    };
  },
  mounted() {
    this.refresh = true;
  },
  methods: {
    handlePass(row, index) {
      console.log("----row", row, index);
      this.isVisiblePass = true;
      this.currentRow = row;
      this.currentIndex = index;
    },
    handleConfirmPass() {
      unReasonableRefundApi
        .adoptUnreasonWork({
          id: this.currentRow.id,
          storehouse_remark: this.storehouse_remark,
        })
        .then(() => {
          this.isVisiblePass = false;
          this.$message.success("通过成功！");
          this.$refs.refuseTable.update(this.currentIndex, {
            id: this.currentRow.no,
          });
        })
        .catch(this.$noop);
    },
    handleReject(row, index) {
      this.currentRow = row;
      this.currentIndex = index;
      this.$confirm("", "确认驳回？", {
        confirmButtonText: "确认",
        confirmButtonClass: "danger",
      })
        .then(() => {
          unReasonableRefundApi
            .rejectUnreasonWork({ id: this.currentRow.id })
            .then(() => {
              this.$message.success("驳回成功！");
              this.$refs.refuseTable.update(this.currentIndex, {
                id: this.currentRow.no,
              });
            })
            .catch(this.$noop);
        })
        .catch(this.$noop);
    },
    handleViewLog(row, index) {
      this.currentRow = row;
      this.currentIndex = index;
      this.isVisibleLog = true;
      this.refreshLog = true;
    },
    handleAbandon(row, index) {
      this.currentRow = row;
      this.currentIndex = index;
      this.$confirm("", "确认弃件？", {
        confirmButtonText: "确认",
      })
        .then(() => {
          unReasonableRefundApi
            .handleDiscardResult({ id: this.currentRow.id })
            .then(() => {
              this.$message.success("弃件成功！");
              this.$refs.refuseTable.update(this.currentIndex, {
                id: this.currentRow.no,
              });
            })
            .catch(this.$noop);
        })
        .catch(this.$noop);
    },
    handleSendBack(row, index) {
      this.currentRow = row;
      this.currentIndex = index;
      this.isVisibleSendBack = true;
    },
    handleConfirmSendBack() {
      this.$refs.formSend.validate((valid) => {
        if (valid) {
          unReasonableRefundApi
            .handleMailResult({ id: this.currentRow.id, ...this.formSend })
            .then(() => {
              this.$message.success("寄出成功！");
              this.isVisibleSendBack = false;
              this.$refs.refuseTable.update(this.currentIndex, {
                id: this.currentRow.no,
              });
            })
            .catch(this.$noop);
        }
      });
    },
    handleRestock(row, index) {
      this.currentRow = row;
      this.currentIndex = index;
      this.warehousingConfirmModalVisible = true;
    },
    confirmWarehousing() {
      this.$refs.refWarehousing.validate((valid) => {
        if (valid) {
          unReasonableRefundApi
            .handleRestartInStockResult({
              id: this.currentRow.id,
              reason_type: this.formWarehousing.reason_type,
            })
            .then(() => {
              this.$message.success("重新入库成功！");
              this.warehousingConfirmModalVisible = false;
              this.$refs.refuseTable.update(this.currentIndex, {
                id: this.currentRow.no,
              });
            })
            .catch(this.$noop);
        }
      });
    },
    handleViewImage(images, index) {
      this.$viewerApi({
        images,
        options: {
          initialViewIndex: index,
        },
      });
    },
    handlePassDialogClose() {
      this.storehouse_remark = "";
    },
    handleSendBackDialogClose() {
      this.$refs.formSend.resetFields();
    },
    openRejectionTimeModal() {
      this.rejectionTimeModalVisible = true;
      unReasonableRefundApi
        .getisjudgmentTime()
        .then((res) => {
          this.formRejectionTime = res;
        })
        .catch(this.$noop);
    },
    confirmRejectionTime() {
      this.$refs.refRejectionTime.validate((valid) => {
        if (valid) {
          unReasonableRefundApi
            .setMisjudgmentTime({ dayNum: this.formRejectionTime.dayNum })
            .then(() => {
              this.$message.success("设置成功");
              this.rejectionTimeModalVisible = false;
            })
            .catch(this.$noop);
        }
      });
    },
    handleRejectionTimeModalClose() {
      this.formRejectionTime = this.$options.data().formRejectionTime;
      this.$refs.refRejectionTime.resetFields();
    },
    handleWarehousingConfirmModalClose() {
      this.formWarehousing = this.$options.data().formWarehousing;
      this.$refs.refWarehousing.resetFields();
    },
  },
};
</script>
<style scoped>
.goods_img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  margin: 0 4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/work/RefuseWorkList.vue